app.components.button = {
    onReady: function () {
        if ($('.c-button').length) {
            return true;
        }
    },
    addListener: function () {
    }
};
